export const REPOSITORY_URL = import.meta.env.VITE_REPOSITORY_URL?.trim()
  || "https://github.com/Zee-SS/ai-signal";
